import React, { useContext, useMemo, useRef, useState } from 'react'
import {
  dateTimeCol,
  intCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import { connect } from 'react-redux'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import {
  getApiTargetInfo,
  getEnvConfig,
  ExportComponent,
  UnitSelection,
} from 'core'
import NetCapVerDataDialog from './NetCapVerDataDialog'
import moment from 'moment'
import { UnitSelectionContext, ErrorContext, SpinContext } from 'context'

import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
} from 'core/selectors'

import { CriteriaRow, Title, Content, FullHeightSizer } from 'core/screen-util'
import {
  rowHeaderRender,
  exportDataComponent,
  hasAccesPermits,
} from 'core/utils'
import { Button, Input, message, Popconfirm, InputNumber, Select } from 'antd'

import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
// import * as Actions from 'core/EventActions'
// import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'
import * as ScreenPermissions from 'core/EventActions'
import {
  // getInstalledCapacitiveClaimedEffective,
  getNetCapacitiveVerification,
  netCapacitiveVerificationDelete,
  // netCapacitiveVerificationUpdate,
} from '../../api/pgads'
import { isErrorContains } from '../../core/component/JcTmpErrorDialog'
import { dataSavedMessage } from '../../core/screen-util'
import JcTmpErrorContext from '../../context/JcTmpErrorContext'
import { unitIdHeader, utilityHeader } from '../../core/HeaderColTypeProps'

const title = 'Net Capacity Verification'

const NetCapacityVerification = ({
  targetInfo,
  actionPermits,
  envConfig,
  unitNameMap,
  utilityNameMap,
}) => {
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { setError } = useContext(ErrorContext)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const GridRef = useRef()
  //   const [insertEvent, setInsertEvent] = useState(false)
  const [year, setYear] = useState(moment().format('YYYY'))
  const [season, setSeason] = useState('S')

  const [data, setData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [selected, setSelected] = useState({})
  const [showEditDialog, setShowdialogData] = useState(false)

  const onCriteriaChnage = _ => setData([])
  const onRetrieve = _ => {
    if (selectedUnits.length <= 0) {
      message.warn('Please,select Unit(s)')
      setVisibleUnitSelection(true)
      return
    }
    const cr = { unit: selectedUnits.map(u => u.unitId), year, season }
    setSpinning(true)
    getNetCapacitiveVerification(targetInfo)(cr).fork(setError, data => {
      setSpinning(false)
      setData(data)
    })
  }
  const onInsertEvent = _ => {
    const dt = moment()
    // const m = dt.format('M')
    const insData = {
      action: 'I',
      teststartdate: moment()
        .clone()
        .date(1)
        .hour(0)
        .minute(0)
        .second(0)
        .format('YYYY-MM-DDTHH:mm:ss'),
      testenddate: moment()
        .clone()
        .date(1)
        .hour(0)
        .minute(0)
        .second(0)
        .format('YYYY-MM-DDTHH:mm:ss'),
      // utility: '297',
      // unit: '505',
      year: dt.format('YYYY'),
      period: 'S',
      testidx: '-99',
      // claimedinstalled: getClaimedInstalled(claimedInstalled, '297505', 'S'),
    }
    setShowdialogData(insData)
  }

  const onUpdate = _ => {
    if (selected.selectedRows.length <= 0) {
      message.warn('Please,select Row')
      return
    }

    const row = selected.selectedRows[0]
    setShowdialogData({
      action: 'U',
      ...row,
      unitId: row.utility + '' + row.unit,
    })
  }

  const onDeleteData = _ => {
    if ((selected.selectedRows || []).length <= 0) {
      message.error('Please , Select Row to Delete')
      return
    }
    setSpinning(true)
    netCapacitiveVerificationDelete(targetInfo)(selected.selectedRows).fork(
      setError,
      tmpError => {
        setSpinning(false)
        if (!isErrorContains(tmpError)) {
          dataSavedMessage()
          onRetrieve()
        }
        setTmpError(tmpError)
      }
    )
  }

  const headerWithFormatter = useMemo(
    _ =>
      VerificationTestHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )

  const netCapacityVerificationWrite = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.NET_CAP_VERIFICATION_WRITE,
          ScreenPermissions.NET_CAP_VERIFICATION_IMPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <div>
      <UnitSelection setData={_ => setData([])} />
      <CriteriaRow>
        <Title>{title}</Title>
        <InputNumber
          onChange={year => {
            setYear(year)
            onCriteriaChnage()
          }}
          value={year}
          style={{ marginLeft: '5px' }}
        />
        {/* <div>Season</div> */}
        <Select
          value={season}
          onChange={val => {
            setSeason(val)
            onCriteriaChnage()
          }}
          allowClear={false}
          style={{ marginLeft: '5px', width: '150px' }}
        >
          <Select.Option value="S" key="S">
            Summer
          </Select.Option>
          <Select.Option value="W" key="W">
            Winter
          </Select.Option>
        </Select>
        <Button
          loading={spinning}
          onClick={onRetrieve}
          style={{ marginLeft: '10px' }}
          type="primary"
          icon="database"
        >
          Retrieve
        </Button>
        {netCapacityVerificationWrite && (
          <Button
            loading={spinning}
            onClick={onInsertEvent}
            icon="plus-circle"
            style={{ backgroundColor: '#e6f7ff', marginLeft: '10px' }}
          >
            Insert
          </Button>
        )}
        {netCapacityVerificationWrite && (
          <Button
            loading={spinning}
            style={{
              marginLeft: '10px',
              // color: '#FFFFFF',
              // backgroundColor:
              //   editInfo.updated.length > 0 || editInfo.added.length > 0
              //     ? '#52c41a'
              //     : 'lightgray',
            }}
            disabled={data.length <= 0}
            onClick={onUpdate}
            icon="edit"
            type="primary"
          >
            Update
          </Button>
        )}
        {netCapacityVerificationWrite && (
          <Popconfirm
            title="Are you sure?"
            okText="Yes"
            cancelText="No"
            onConfirm={onDeleteData}
            // disabled={selected.selectedRows && selected.selectedRows.length <= 0}
            placement="topRight"
            // disabled
          >
            <Button
              loading={spinning}
              icon="delete"
              style={{
                marginLeft: '10px',
                // color: '#FFFFFF',
                // backgroundColor: '#FF0000',
              }}
              type="danger"
              disabled={
                selected.selectedRows && selected.selectedRows.length <= 0
              }
            >
              Remove
            </Button>
          </Popconfirm>
        )}
        <div style={{ flex: '1 1 0px' }} />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          data={data}
          headers={(VerificationTestHeaders || []).map(d => ({
            ...d,
            rowHeaderBackgroundColor: '#eee',
          }))}
          fileName={title}
          btnStyle={{ marginRight: '10px' }}
          disabled={data.length <= 0}
        />
      </CriteriaRow>
      {showEditDialog && (
        <NetCapVerDataDialog
          visible={!!showEditDialog}
          data={showEditDialog}
          // insertData={showEditDialog}
          // setInsertData={setShowdialogData}
          onCancel={_ => setShowdialogData(false)}
          targetInfo={targetInfo}
          onRetrieve={onRetrieve}
        />
      )}
      <FullHeightSizer heightOffset={250}>
        {({ height, width }) => (
          <Content style={{ height: height - 20 }}>
            <Grid
              ref={GridRef}
              // editMode="cell"
              data={data || []}
              headers={headerWithFormatter}
              altBy={o => o.unitId}
              altBgColor="#ebebeb"
              render={virtualizedGridRenderer({
                autoFixColByKey: false,
                rowHeaderRender,
                height: height - 40,
                width: width - 50,
                headerRowHeight: 60,
              })}
              fuzzyFilter={fuzzyFilter}
              onSelectionChange={selected => {
                setSelected(selected)
              }}
              initialSortOptions={VerificationTestHeaders}
              sortOptions={VerificationTestHeaders}
              sortEnabled
              isEditable={false}
              selectionType="row"
              selectionMode="single"
            />
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )

  // return (
  //   <CommonScreen
  //     defaultInsertData={{
  //       utility: '297',
  //       unit: '505',
  //       year: '2021',
  //       period: 'S',
  //       testidx: '11',
  //       claimedinstalled: getClaimedInstalled('297505', 'S'),
  //     }}
  //     withCriteria={withCriteria}
  //     screenCriteria={screenCriteria}
  //     withUnitSelection
  //     isAdminScreen={false}
  //     title={title}
  //     header={VerificationTestHeaders}
  //     saveTask={netCapacitiveVerificationUpdate}
  //     retrieveTask={getNetCapacitiveVerification}
  //     deleteTask={netCapacitiveVerificationDelete}
  //     altBy={d => d.year + d.utility + d.unit + d.period}
  //     autoRetrieve={false}
  //     sortOptions={VerificationTestHeaders}
  //     widthOffset={50}
  //     insertComp={insertEvent && insertComp}
  //     insertCompHeight={300}
  //     onInsertEvent={b => setInsertEvent(b)}
  //     autoFixColByKey={false}
  //   />
  // )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(NetCapacityVerification)

const VerificationTestHeaders = [
  // strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  // strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  utilityHeader,
  unitIdHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true }),
  strCol({ ident: 'period', display: 'Period', isKey: true }),
  intCol({ ident: 'testidx', display: 'Test Index', isKey: true }),
  numCol({ ident: 'correctednet', display: 'Corrected Net', isFiltered: true }),
  numCol({
    ident: 'claimedinstalled',
    display: 'Claimed Installed',
    isFiltered: true,
  }),
  numCol({ ident: 'difference', display: 'Difference', isFiltered: true }),
  strCol({ ident: 'unittype', display: 'Unit Type', isFiltered: true }),
  dateTimeCol({
    ident: 'teststartdate',
    display: 'Test Start Date',
    isFiltered: true,
    width: 150,
  }),
  dateTimeCol({
    ident: 'testenddate',
    display: 'Test End Date',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'grossmw', display: 'Gross MW', isFiltered: true }),
  numCol({
    ident: 'stationservice',
    display: 'Station Service',
    isFiltered: true,
  }),
  numCol({
    ident: 'processloadserved',
    display: 'Process Load Served',
    isFiltered: true,
  }),
  numCol({
    ident: 'nettestcapability',
    display: 'Net Test Capability',
    isFiltered: true,
  }),
  numCol({
    ident: 'reactivegenmvar',
    display: 'Reactive Generation MVAR',
    isFiltered: true,
  }),
  numCol({
    ident: 'totalpowermva',
    display: 'Total Power MVA',
    isFiltered: true,
  }),
  numCol({ ident: 'powerfactor', display: 'Power Factor', isFiltered: true }),
  numCol({
    ident: 'dryairtempObserved',
    display: 'Dry Air Temperature Observed',
    isFiltered: true,
  }),
  numCol({
    ident: 'dryairtempRated',
    display: 'Dry Air Temperature Rated',
    isFiltered: true,
  }),
  numCol({
    ident: 'airtempmwCorr',
    display: 'Air Temperature Correction',
    isFiltered: true,
  }),
  numCol({
    ident: 'relhumidityObserved',
    display: 'Relative Humidity Observed',
    isFiltered: true,
  }),
  numCol({
    ident: 'relhumidityRated',
    display: 'Relative Humidity Rated',
    isFiltered: true,
  }),
  numCol({
    ident: 'relhumiditymwCorr',
    display: 'Relative Humidity Correction',
    isFiltered: true,
  }),
  numCol({
    ident: 'cwatertempObserved',
    display: 'Cooling Water Temperature Observed',
    isFiltered: true,
  }),
  numCol({
    ident: 'cwatertempRated',
    display: 'Cooling Water Temperature Rated',
    isFiltered: true,
  }),
  numCol({
    ident: 'cwatertempmwCorr',
    display: 'Cooling Water Temperature Correction',
    isFiltered: true,
  }),
  numCol({
    ident: 'iwatertempObserved',
    display: 'Intake Water Temperature Observed',
    isFiltered: true,
  }),
  numCol({
    ident: 'iwatertempRated',
    display: 'Intake Water Temperature Rated',
    isFiltered: true,
  }),
  numCol({
    ident: 'iwatertempmwCorr',
    display: 'Intake Water Temperature Correction',
    isFiltered: true,
  }),
  numCol({
    ident: 'wetairtempObserved',
    display: 'Wet Bulb Temperature Observed',
    isFiltered: true,
  }),
  numCol({
    ident: 'wetairtempRated',
    display: 'Wet Bulb Temperature Rated',
    isFiltered: true,
  }),
  numCol({
    ident: 'wetairtempmwCorr',
    display: 'Wet Bulb Temperature Correction',
    isFiltered: true,
  }),
  numCol({
    ident: 'barometricObserved',
    display: 'Barometric Pressure Observed',
    isFiltered: true,
  }),
  numCol({
    ident: 'barometricRated',
    display: 'Barometric Pressure Rated',
    isFiltered: true,
  }),
  numCol({
    ident: 'barometricmwCorr',
    display: 'Barometric Pressure Correction',
    isFiltered: true,
  }),
  strCol({
    ident: 'observedSiteCode',
    display: 'Observed Site Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'observedSiteSpecified',
    display: 'Observed Site Specified',
    isFiltered: true,
  }),
  strCol({
    ident: 'ratedSiteCode',
    display: 'Rated Site Code',
    isFiltered: true,
  }),
  strCol({
    ident: 'ratedSiteSpecified',
    display: 'Rated Site Specified',
    isFiltered: true,
  }),
  strCol({
    ident: 'note',
    display: 'Note',
    isFiltered: true,
    width: 400,
    alignment: 'left',
    ellipsis: true,
  }),
  modifierCol,
  modifiedDateCol,
].map(d => ({ ...d, width: d.width || 180 }))
